module.exports = __webpack_public_path__ + "img/report_pic10.4b143273.png";